import React, { useContext } from 'react';

import { PAGE_TYPES_WITH_IMAGES } from '../../../constants';
import { PDFDataContext } from '../../../context';
import Image from '../../shared/Image';
import Title from '../../shared/Title';
import { getBlockConfig } from './config';

function Blocks({ items }) {
  const { showImages } = useContext(PDFDataContext);

  return items.map((b, i) => {
    if (!b) {
      return null;
    }

    const { Component } = getBlockConfig({ type: b.type });

    if (!Component) {
      return null;
    }

    const isNewPage = items[i - 1] && items[i - 1].pageTitle !== b.pageTitle;
    const showImage = showImages && PAGE_TYPES_WITH_IMAGES.includes(b.pageType);

    return (
      <React.Fragment key={i}>
        {isNewPage && (
          <div style={{ marginTop: 50 }}>
            <Title text={b.pageTitle} withBorder={b.type !== 'header'} />
            {showImage && b.image && <Image url={b.image} focalPointCoords={b.primaryImageCoords} />}
          </div>
        )}
        <Component block={b} />
      </React.Fragment>
    );
  });
}

export default Blocks;
